<template>
  <section class="orders">
    <div class="status">
      <div class="status__heading">
        <h1>
          Orders
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon slot="activator" class="info-icon" v-on="on">mdi-information</v-icon>
            </template>
            <span>These items are separated by Full and Partial documents.</span>
            <br />
            <span>If there is an order that needs to be expedited, select Urgent and [process accordingly].</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="refresh-btn">
                <v-icon
                  class="refresh-icon"
                  v-ripple
                  :color="'#a9a9a9'"
                  v-on="on"
                  @click="refresh"
                >mdi-refresh</v-icon>
              </span>
            </template>
            <span>Refresh data</span>
          </v-tooltip>
        </h1>
      </div>
      <div class="status__column">
        <div class="status__column-heading">VIEW BY STATUS</div>
        <a href @click="refresh()">
          <StatusItem link="/orders" label="New Orders">
            <template v-slot:icon>
              <v-icon :color="newOrdersColor">mdi-marker-check</v-icon>
            </template>
          </StatusItem>
        </a>
        <a href @click="refresh()">
          <StatusItem link="/orders/errors" label="Errors">
            <template v-slot:icon>
              <v-icon :color="errorsColor">mdi-alert</v-icon>
            </template>
          </StatusItem>
        </a>
        <!-- <a href @click="refresh()"> -->
        <!--   <StatusItem link="/orders/urgent" label="Urgent"> -->
        <!--     <template v-slot:icon> -->
        <!--       <v-icon :color="urgentColor">mdi-alert-circle</v-icon> -->
        <!--     </template> -->
        <!--   </StatusItem> -->
        <!-- </a> -->
        <div class="divider"></div>
        <a href @click="refresh()">
          <StatusItem link="/orders/processed" label="Processed Orders">
            <template v-slot:icon>
              <v-icon :color="archivedColor">mdi-package-down</v-icon>
            </template>
          </StatusItem>
        </a>
      </div>
    </div>
    <div class="content">
      <div class="content__actions">
        <div class="content__actions-left">
          <div class="search">
            <div class="search-icon">
              <v-icon :color="'#a9a9a9'">mdi-magnify</v-icon>
            </div>
            <div class="search-input">
              <input v-model="search" type="text" placeholder="Search" />
            </div>
          </div>
        </div>
        <div class="content__actions-middle">
          <div class="process">
            <p class="font-label">Font</p>
            <v-radio-group
              v-model="font"
              row
              >
              <v-radio
                class="font-radio"
                label="UTL"
                value="UTLX5"
                ></v-radio>
              <v-radio
                class="font-radio"
                label="AAR"
                value="AARS910vAD"
                ></v-radio>
            </v-radio-group>
          </div>
        </div>
        <div class="content__actions-right">
          <div class="process">
            <!-- <v-btn -->
            <!--   class="process-urgent" -->
            <!--   :color="'#CB201F'" -->
            <!--   outlined -->
            <!--   @click="processUrgent" -->
            <!-- >Process Urgent Orders</v-btn> -->
            <v-btn
              class="process-new"
              :color="'#CB201F'"
              @click="processReady"
            >Process Ready Orders</v-btn>
          </div>
        </div>
      </div>
      <div class="table">
        <OrdersTable :search="search" :orders="documents" :loading="loading"></OrdersTable>
      </div>
    </div>
  </section>
</template>

<script>
import OrdersTable from '../components/OrdersTable.vue';
import StatusItem from '../components/StatusItem';
import moment from 'moment';
import API from '../services/API';

export default {
  name: 'orders',
  components: {
    OrdersTable,
    StatusItem,
  },
  data() {
    return {
      search: '',
      documents: [],
      loading: false,
      locks: {},
      font: 'AARS910vAD',
    };
  },
  computed: {
    newOrdersColor() {
      return this.$route.path === '/orders' ? '#51b71b' : '#a9a9a9';
    },
    errorsColor() {
      return this.$route.path === '/orders/errors' ? '#cb201f' : '#a9a9a9';
    },
    urgentColor() {
      return this.$route.path === '/orders/urgent' ? '#cb201f' : '#a9a9a9';
    },
    archivedColor() {
      return this.$route.path === '/orders/processed' ? '#000' : '#a9a9a9';
    },
  },
  methods: {
    processReady() {
      if (this.locks.processReady) {
        return;
      }

      this.locks.processReady = true;
      API.post('/batches', { type: 'ready', font: this.font })
          .catch((e) => console.error(e))
          .then(() => {
            this.refresh();
            this.locks.processReady = false;
          });
    },
    processUrgent() {
      if (this.locks.processUrgent) {
        return;
      }

      this.locks.processUrgent = true;
      API.post('/batches', { type: 'urgent', font: this.font })
          .catch((e) => console.error(e))
          .then(() => {
            this.refresh();
            this.locks.processUrgent = false;
          });
    },
    refresh() {
      this.loading = true;
      this.documents = [];
      let target = '/documents';
      if ((this.$route || {}).path === '/orders/processed') {
        target += '?processed=true';
      }
      API.get(target)
          .then((documents) => {
            const datesFormattedDocs = documents.data.map((doc) => {
              doc.formattedDate = moment(doc.date).format('MMMM Do, YYYY');
              return doc;
            });
            switch (this.$route.path) {
              case '/orders/errors':
                this.documents = datesFormattedDocs.filter((doc) => doc.error);
                break;
              case '/orders/urgent':
                this.documents = datesFormattedDocs.filter((doc) => doc.urgent);
                break;
              case '/orders/processed':
                this.documents = datesFormattedDocs.filter((doc) => doc.outputId);
                break;
              default:
                this.documents = datesFormattedDocs;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .then(() => (this.loading = false));
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style lang="scss" scoped>
@import "../main.scss";

.orders {
  padding: 1.5rem 0;
  width: 100%;
  min-width: 1200px;
  max-width: 2880px;
  height: 100%;
  display: grid;
  grid-template-columns: 320px 1fr 60px;
  background: #fff;

  .status {
    height: 100%;

    display: flex;
    flex-wrap: wrap;

    &__heading {
      height: 10rem;
      width: 100%;
      z-index: 1;

      display: flex;
      justify-content: center;
      align-items: center;

      h1 {
        height: 4.7rem;
        width: 18rem;
        color: #212121;
        font-family: Heebo;
        font-size: 3.2rem;
        font-weight: bold;
        line-height: 4.7rem;
        padding-right: 10px;

        .info-icon {
          font-size: 18px;
          margin-bottom: 1.4rem;
        }
      }

      .refresh-btn {
        border: 2px solid #dedede;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 35px;
        width: 35px;
        margin-top: 4px;
        float: right;
      }
    }

    &__column {
      width: 100%;
      height: 100%;
      z-index: 5;

      &-heading {
        margin: 0 auto;
        height: 2.1rem;
        margin-top: 1.7rem;
        margin-bottom: 1.5rem;
        width: 17rem;
        color: #212121;
        font-family: Heebo;
        font-size: 1.4rem;
        font-weight: bold;
        letter-spacing: 1.24px;
        line-height: 2.1rem;
      }

      .divider {
        width: 17rem;
        height: 0.1rem;
        border-bottom: 2px solid #a9a9a9;
        margin: 0.5rem auto;
      }

      & > a {
        text-decoration: none;
      }
    }
  }

  .content {
    height: 100%;
    padding: 0;

    display: flex;
    flex-direction: column;

    &__actions {
      height: 10rem;
      width: 100%;

      display: flex;

      &-left {
        width: 40%;
        height: 100%;

        display: flex;
        align-items: center;

        .search {
          min-width: 27rem;
          width: 60%;
          height: 3.9rem;
          border: 2px solid #dedede;
          border-radius: 6px;

          display: flex;
          flex-direction: row;

          &-icon {
            width: 3.5rem;
            height: 100%;
            padding-left: 0.5rem;
            display: block;

            display: flex;
            align-items: center;
          }

          &-input {
            width: 100%;
            height: 100%;
            display: block;

            display: flex;
            align-items: center;
            border-radius: 6px;

            input {
              width: 100%;
              height: 100%;
              font-family: Heebo;
              font-size: 16px;
              line-height: 24px;

              &::placeholder {
                color: #a9a9a9;
              }

              &:focus {
                outline: none;
              }
            }
          }
        }
      }

      &-middle {
        width: 20%;
      }

      &-right {
        width: 40%;
        height: 100%;

        .process {
          width: 100%;
          height: 100%;

          display: flex;
          justify-content: flex-end;
          align-items: center;
          flex-wrap: wrap;

          &-urgent,
          &-new {
            font-family: Heebo;
            letter-spacing: 0.5px;
            font-size: 1.5rem;
            line-height: 24px;
            text-align: center;
            text-transform: none;
            width: 48%;
          }

          &-urgent {
            height: 40px;
            min-width: 17.5rem;
            border-radius: 6px;
          }

          &-new {
            height: 40px;
            min-width: 14.5rem;
            border-radius: 6px;
            color: #fff;
          }
        }
      }
    }
  }

  .font-label {
    font-size: 2em;
  }

  .font-radio {
    margin-right: 1em;
  }
}
</style>
